import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxMultiSelectFilter} from "./ngx-multi-select-filter";
import {Filter} from "../../../ngx-types";

@Component({
  selector: 'app-multi-select-box',
  templateUrl: './multi-select-box.component.html',
  styleUrls: ['./multi-select-box.component.scss']
})
export class MultiSelectBoxComponent extends NgxMultiSelectFilter implements OnInit {
  @Input() label: string;
  @Input() filter: Filter;
  @Input() options: any;
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();


  ngOnInit(): void {
  }

}
